var dispatchInputChange = function dispatchInputChange(element, value) {
  var _element$tagName, _nativeDescriptor$set;

  if (!element || !window) {
    return;
  }

  var INPUT_EVENT = new Event('input', {
    bubbles: true
  });
  var ElementPrototype = new Map();
  var tagName = (_element$tagName = element.tagName) != null ? _element$tagName : 'INPUT';
  ElementPrototype.set('INPUT', HTMLInputElement.prototype);
  ElementPrototype.set('TEXTAREA', HTMLTextAreaElement.prototype);
  var nativeDescriptor = Object.getOwnPropertyDescriptor(ElementPrototype.get(tagName), 'value');
  nativeDescriptor == null ? void 0 : (_nativeDescriptor$set = nativeDescriptor.set) == null ? void 0 : _nativeDescriptor$set.call(element, value);
  element.dispatchEvent(INPUT_EVENT);
};

export { dispatchInputChange };